<template>
  <div class="user-page">

    <!-- 顶部用户信息 -->
    <div class="header" @click="!isLogin && $router.push('/login')">
      <div class="avatar-wrapper">
        <img class="avatar" src="@/assets/default-avatar.png" alt="头像" />
      </div>

      <div v-if="isLogin" class="info">
        <div class="username">{{ detail.username }}</div>
        <div class="vip-tag">
          <van-icon name="diamond-o" />
          注册用户
        </div>
      </div>

      <div v-else class="info">
        <div class="username not-login">未登录</div>
        <div class="login-tip">点击登录账号</div>
      </div>
    </div>

    <!-- 用户信息（用 van-field 显示） -->
    <div class="info-fields">
      <van-field
        label="用户名"
        :value="detail.username || '未设置'"
        readonly
        disabled
        input-align="right"
      />
      <van-field
        label="邮箱"
        :value="detail.email || '未设置'"
        readonly
        disabled
        input-align="right"
      />
      <van-field
        label="手机号"
        :value="detail.phone || '未设置'"
        readonly
        disabled
        input-align="right"
      />
      <van-field
        label="全名"
        :value="detail.full_name || '未设置'"
        readonly
        disabled
        input-align="right"
      />
      <van-field
        label="注册时间"
        :value="detail.created_at ? formatDate(detail.created_at) : '-'"
        readonly
        disabled
        input-align="right"
      />
    </div>

    <!-- 退出登录按钮 -->
    <div v-if="isLogin" class="logout-area">
      <van-button type="danger" round block @click="logout">
        退出登录
      </van-button>
    </div>

  </div>
</template>

<script>
import { getUserInfoDetail } from '@/api/user.js'

export default {
  name: 'UserIndex',
  data () {
    return {
      detail: {}
    }
  },
  computed: {
    isLogin () {
      return !!this.$store.getters.token
    }
  },
  created () {
    if (this.isLogin) {
      this.loadUserDetail()
    }
  },
  methods: {
    async loadUserDetail () {
      try {
        const { data } = await getUserInfoDetail()
        this.detail = data
      } catch (e) {
        console.error('获取用户信息失败', e)
      }
    },
    formatDate (isoString) {
      const d = new Date(isoString)
      const year = d.getFullYear()
      const month = String(d.getMonth() + 1).padStart(2, '0')
      const date = String(d.getDate()).padStart(2, '0')
      const hours = String(d.getHours()).padStart(2, '0')
      const mins = String(d.getMinutes()).padStart(2, '0')
      return `${year}-${month}-${date} ${hours}:${mins}`
    },
    logout () {
      this.$dialog.confirm({
        title: '温馨提示',
        message: '确定退出登录吗？'
      }).then(() => {
        this.$store.dispatch('user/logout')
        this.detail = {}
        this.$router.replace('/home')
      })
    }
  }
}
</script>

<style lang="less" scoped>
.user-page {
  min-height: 100vh;
  background-color: #f5f5f5;
  padding-bottom: 20px;
}

/* 顶部区域美化 */
.header {
  background: linear-gradient(135deg, #6e9fff, #4c7dff);
  padding: 35px 20px 25px;
  text-align: center;
  color: #fff;
  display: flex;
  align-items: center;
  flex-direction: column;

  .avatar-wrapper {
    width: 80px;
    height: 80px;
    border-radius: 50%;
    overflow: hidden;
    border: 3px solid #ffffff80;
    margin-bottom: 12px;

    .avatar {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }

  .info {
    text-align: center;

    .username {
      font-size: 18px;
      font-weight: bold;
      margin-bottom: 4px;

      &.not-login {
        opacity: 0.9;
      }
    }

    .login-tip {
      font-size: 14px;
      opacity: 0.8;
    }

    .vip-tag {
      margin-top: 6px;
      display: inline-flex;
      align-items: center;
      background: rgba(255,255,255,0.2);
      padding: 4px 10px;
      border-radius: 20px;
      font-size: 12px;

      .van-icon {
        margin-right: 4px;
        color: #ffdd55;
      }
    }
  }
}

.info-fields {
  background: #fff;
  border-radius: 10px;
  padding: 5px 0;

  .van-field {
    padding: 12px 16px;
  }
}

.logout-area {
  margin: 25px 20px 0;
}
</style>
